export default __webpack_public_path__ + "static/media/database.0798a898.jpg";